import React from "react";
import { ZoomInIcon, ZoomOutIcon, DownloadIcon, PrevIcon, NextIcon, CloseIcon, RotateIcon } from "./icons";

var Header = function Header(_ref) {
  var image = _ref.image,
      fileName = _ref.alt, // SHVG
      alt = _ref.alt,
      zoomed = _ref.zoomed,
      toggleZoom = _ref.toggleZoom,
      toggleRotate = _ref.toggleRotate,
      onClose = _ref.onClose,
      onNext = _ref.onNext,
      onPrev = _ref.onPrev,
      loading = _ref.loading,       
      enableDownload = _ref.enableDownload,
      enableZoom = _ref.enableZoom,
      enableRotate = _ref.enableRotate;
  return React.createElement("div", {
    className: "__react_modal_image__header"
  }, React.createElement("span", {
    className: "__react_modal_image__icon_menu"
  }, 
  /// SHVG
  onPrev && React.createElement("a", { onClick: !loading ? onPrev : undefined, }, React.createElement(PrevIcon, null)),
  onNext && React.createElement("a", { onClick: !loading ? onNext : undefined, }, React.createElement(NextIcon, null)),
  /// ----  
  enableDownload && React.createElement("a", {
    href: image,
    download: fileName // SHVG
  }, React.createElement(DownloadIcon, null)),
  enableZoom && React.createElement("a", {
    onClick: toggleZoom
  }, zoomed ? React.createElement(ZoomOutIcon, null) : React.createElement(ZoomInIcon, null)), 
  enableRotate && React.createElement("a", {
    onClick: toggleRotate
  }, React.createElement(RotateIcon, null)), React.createElement("a", {
    onClick: onClose
  }, React.createElement(CloseIcon, null))), alt && React.createElement("span", {
    className: "__react_modal_image__caption"
  }, alt));
};

export default Header;